import { createFileRoute } from "@tanstack/react-router";
import { SettingsIntegrationsPage } from "@/pages/SettingsIntegrationsPage";

export const Route = createFileRoute("/_app/settings/integrations")({
  component: SettingsIntegrationsPage
});
